import { render, staticRenderFns } from "./ComboGetProjetoByUf.vue?vue&type=template&id=6e304d65&scoped=true"
import script from "./ComboGetProjetoByUf.vue?vue&type=script&lang=js"
export * from "./ComboGetProjetoByUf.vue?vue&type=script&lang=js"
import style0 from "./ComboGetProjetoByUf.vue?vue&type=style&index=0&id=6e304d65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e304d65",
  null
  
)

export default component.exports